import { createAction } from "@ngrx/store";

import { BogCurrencyInformationModel } from "../models/currency.model";
export const ADD_CURRENCY = createAction(
  "ADD_CURRENCY",
  (currency: BogCurrencyInformationModel) => ({
    currency,
  }),
);
